<section class="tc-links" aria-labelledby="tc-links-heading">
  <h3 id="tc-links-heading" class="tc-links__title">{{ 'testCases.form.links.blockTitle' | translate }}</h3>

  @if (loading()) {
    <div class="tc-links__loading">
      <mat-spinner diameter="28" />
    </div>
  } @else if (loadError()) {
    <p class="tc-links__hint tc-links__hint--error" role="alert">
      {{ 'testCases.form.links.loadError' | translate }}
    </p>
  } @else {
    <ul class="tc-links__list">
      @for (link of links(); track link.id) {
        <li class="tc-links__item">
          <span class="tc-links__icon tc-links__icon--{{ modifierFor(link.type) }}" aria-hidden="true">
            @if (link.type === 'GITHUB') {
              <svg
                class="tc-links__icon-svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 .5C5.7.5.5 5.7.5 12c0 5.1 3.3 9.4 7.9 10.9.6.1.8-.3.8-.6v-2c-3.2.7-3.9-1.4-3.9-1.4-.5-1.3-1.3-1.7-1.3-1.7-1.1-.7.1-.7.1-.7 1.2.1 1.8 1.2 1.8 1.2 1 1.8 2.7 1.3 3.4 1 .1-.8.4-1.3.7-1.6-2.6-.3-5.3-1.3-5.3-5.7 0-1.3.5-2.3 1.2-3.1-.1-.3-.5-1.5.1-3.1 0 0 1-.3 3.3 1.2a11 11 0 0 1 6 0c2.3-1.5 3.3-1.2 3.3-1.2.6 1.6.2 2.8.1 3.1.8.8 1.2 1.9 1.2 3.1 0 4.4-2.7 5.4-5.3 5.7.4.4.8 1.1.8 2.2v3.3c0 .3.2.7.8.6A11.5 11.5 0 0 0 23.5 12C23.5 5.7 18.3.5 12 .5z"
                />
              </svg>
            } @else {
              <mat-icon>{{ iconFor(link.type) }}</mat-icon>
            }
          </span>
          <span class="tc-links__body">
            @if (externalUrl(link); as url) {
              <a
                class="tc-links__ref"
                [href]="url"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="
                  (link.displayLabel || link.reference) + ' — ' + ('testCases.form.links.openInNewTab' | translate)
                "
              >
                {{ link.displayLabel || link.reference }}
              </a>
            } @else {
              <span class="tc-links__ref">{{ link.displayLabel || link.reference }}</span>
            }
            <span class="tc-links__type">{{ 'testCases.form.links.types.' + link.type | translate }}</span>
          </span>
          <button
            type="button"
            class="tc-links__remove"
            (click)="onRemove(link)"
            [attr.aria-label]="
              ('testCases.form.links.removeAria' | translate) + ' ' + (link.displayLabel || link.reference)
            "
          >
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </li>
      } @empty {
        <li class="tc-links__empty">{{ 'testCases.form.links.empty' | translate }}</li>
      }
    </ul>

    @if (mutationError()) {
      <p class="tc-links__hint tc-links__hint--error" role="alert">
        {{ 'testCases.form.links.mutationError' | translate }}
      </p>
    }

    <button type="button" class="tc-links__add" data-testid="tc-link-add" (click)="requestAddModal()">
      <mat-icon aria-hidden="true">add</mat-icon>
      {{ 'testCases.form.links.addButton' | translate }}
    </button>

    @if (hasPendingChanges()) {
      <p class="tc-links__hint">{{ 'testCases.form.links.draftHint' | translate }}</p>
    }
  }
</section>
